import AbTestHttpService from 'abTests/AbTestHttpService';
import { silent } from './lib/AbTestWrapper';

export default class CoreXhrAbTestClass {
    constructor({ isAA = false } = {}) {
        this.isAA = isAA;
        this.$abTestHttpService = new AbTestHttpService({ isAA: this.isAA });
        this.AbTestsConfigs = CBS.AbTestsConfigs ? CBS.AbTestsConfigs : {};
        this.experimentsModules = this.loadExperimentsModuleInfoFromRegistry() ?? {};
        // Sets default xhr experiment keys array based on registry config
        this.tests = this.__getXhrExperimentsModuleNamesAsArray();
        this.addVariantClassesToBody = addVariantClassesToBody;
    }

    /**
     * DEPRECATED - remove after experiments are cleaned and migrated to the new js framework
     */
    loadXhrTestsFromRegistry() {
        return this.AbTestsConfigs.hasOwnProperty('XhrABTests') &&
            Object.keys(this.AbTestsConfigs.XhrABTests).length > 0
            ? this.AbTestsConfigs.XhrABTests
            : {};
    }

    /**
     * DEPRECATED - remove after experiments are cleaned and migrated to the new js framework
     */
    loadTestsConstantsFromRegistry() {
        return this.AbTestsConfigs.hasOwnProperty('XhrABTestsConstants') &&
            Object.keys(this.AbTestsConfigs.XhrABTestsConstants).length > 0
            ? this.AbTestsConfigs.XhrABTestsConstants
            : {};
    }

    loadExperimentsModuleInfoFromRegistry() {
        return this.AbTestsConfigs.hasOwnProperty('modules')
            ? this.AbTestsConfigs.modules ?? {}
            : {};
    }

    __getXhrExperimentsModuleNamesAsArray() {
        return Object.keys(this.experimentsModules)
            .map((key) => {
                return this.experimentsModules[key].isXHR
                    ? this.experimentsModules[key]?.experimentKey
                    : false;
            })
            .filter((value) => value !== false);
    }

    initTests(tests = this.tests) {
        return new Promise((resolve, reject) => {
            this.$abTestHttpService
                .getVariantMultipleTests(tests)
                .then((resp) => {
                    const newOptimizelyExperiments = resp.variants;
                    if (newOptimizelyExperiments) {
                        removeVariantClassesFromBody();
                        this.addVariantsToTracking(newOptimizelyExperiments);
                        this.addVariantClassesToBody(newOptimizelyExperiments);
                    }
                    resolve(resp);
                })
                .catch((e) => {
                    if (!silent) {
                        console.log(e);
                    }
                });
        });
    }

    addVariantsToTracking(newOptimizelyExperiments, trackOn = true) {
        let optimizelyExperiments = [];

        if (utag_data.optimizelyExp) {
            optimizelyExperiments = utag_data.optimizelyExp.split('|');
        }

        // then append the new optimizely experiments pulled through our XHR to utag data
        for (const test in newOptimizelyExperiments) {
            if (!optimizelyExperiments.includes(`${test}:${newOptimizelyExperiments[test]}`)) {
                optimizelyExperiments.push(`${test}:${newOptimizelyExperiments[test]}`);
            }
        }

        if (Object.keys(newOptimizelyExperiments).length > 0) {
            Object.keys(newOptimizelyExperiments).forEach((key) => {
                const experimentAsOptimizelyString = `${key}:${newOptimizelyExperiments[key]}`;
                if (!optimizelyExperiments.includes(experimentAsOptimizelyString)) {
                    optimizelyExperiments.push(experimentAsOptimizelyString);
                }
            });
        }

        if (trackOn) this.trackingVariants(optimizelyExperiments);
        return optimizelyExperiments;
    }

    trackingVariants(optimizelyExperiments) {
        let omInterval = setInterval(function () {
            if (typeof om != 'undefined') {
                try {
                    om.trackAction('trackOptimizelyExpXHR', {
                        optimizelyExp: optimizelyExperiments.join('|'),
                    });
                    utag_data.optimizelyExp = optimizelyExperiments.join('|');
                } catch (e) {
                    console.error(e);
                }
                clearInterval(omInterval);
            }
        }, 200);
    }
}

export function addVariantClassesToBody(newOptimizelyExperiments) {
    const docElem = document.documentElement;
    const bodyElem = docElem.querySelector('body');
    const new_classes = [];
    for (const test in newOptimizelyExperiments) {
        new_classes.push(`test-${test}-${newOptimizelyExperiments[test]}`);
    }
    bodyElem.classList.add(...new_classes);
}

export function removeVariantClassesFromBody() {
    const docElem = document.documentElement;
    const bodyElem = docElem.querySelector('body');
    const existingClasses = [...bodyElem.classList];

    // remove all classes that start with "test-"
    existingClasses.forEach((item, index, classes) => {
        if (item.indexOf('test-') === 0) {
            bodyElem.classList.remove(item);
        }
    });
}
